import { FormGroup } from "@angular/forms";

export class FormUtils {
  public static TELEFONE_MASK =['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public static CELULAR_MASK = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public static PLACA_MASK =   [/[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /\d/, /[A-Za-z0-9]/, /\d/, /\d/];
  public static CEP_MASK =     [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  public static CPF_MASK =     [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public static CNPJ_MASK =    [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
  public static NR_PROTOCOLO = [/[A-Za-z0-9!@#$%^&*()-_=+\[\]]/, /[A-Za-z0-9!@#$%^&*()-_=+\[\]]/, /[A-Za-z0-9!@#$%^&*()-_=+\[\]]/, /[A-Za-z0-9!@#$%^&*()-_=+\[\]]/, /[A-Za-z0-9!@#$%^&*()-_=+\[\]]/, '/', /[A-Za-z0-9!@#$%^&*()-_=+\[\]]/, /[A-Za-z0-9!@#$%^&*()-_=+\[\]]/, /[A-Za-z0-9!@#$%^&*()-_=+\[\]]/, /[A-Za-z0-9!@#$%^&*()-_=+\[\]]/];

  public static CPF_CNPJ_MASK = (input) => {
    let numbers = input.match(/\d/g);
    let numberLength = 0;
    if (numbers)
        numberLength = numbers.join("").length;

    return (numberLength <= 11) ? FormUtils.CPF_MASK : FormUtils.CNPJ_MASK;
};

  static markAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control: any = formGroup.get(field);

      if (control.controls) {
        Object.keys(control.controls).forEach(field2 => {
          const control2: any = control.get(field2);
          control2.markAsTouched({ onlySelf: true });
        });
      } else {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  public static CELULAR_TELEFONE_MASK = (input) => {
    let numbers = input.match(/\d/g)
    let numberLength = 0
    if (numbers)
        numberLength = numbers.join('').length

    return (numberLength <= 10) ? FormUtils.TELEFONE_MASK : FormUtils.CELULAR_MASK
}
}